import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';
import { epinRoles } from '@/mocks/epin';

export default function EpinRoles() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <SectionHeading
          title="九大角色，一张协同网络"
          subtitle="从田间到餐桌，生产者、村集体、质检、县域服务、物流、商户、消费者、平台与监管各司其职，环环相扣。"
        />

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {epinRoles.map((role, idx) => (
            <Reveal key={role.key}>
              <div className="h-full flex flex-col p-6 rounded-lg bg-background-50 border border-background-200 transition-transform duration-300 hover:-translate-y-1">
                <div className="flex items-center gap-3">
                  <span className="w-11 h-11 shrink-0 flex items-center justify-center rounded-md bg-primary-100 text-primary-700">
                    <i className={`${role.icon} text-xl`}></i>
                  </span>
                  <div className="min-w-0">
                    <span className="text-[11px] font-semibold tracking-widest text-foreground-400">
                      {String(idx + 1).padStart(2, '0')}
                    </span>
                    <h3 className="font-heading font-bold text-base text-foreground-950 leading-snug">
                      {role.name}
                    </h3>
                  </div>
                </div>

                <div className="mt-4 inline-flex w-fit px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-900 text-xs">
                  {role.scope}
                </div>

                <p className="mt-3 text-sm text-foreground-600 leading-relaxed">{role.summary}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}